import React, { ChangeEvent, useEffect, useRef, useState } from 'react'
import TextField from '@mui/material/TextField'
import { debounce } from 'ts-debounce'
import { useSelector } from 'react-redux'
import { datatableSelectors } from '@/react-components/datatable/store'

const DEBOUNCE_DELAY = 600

type Props = {
	onChange: (value: any) => void
	dataKey: string
}

const DatatableFulltextFilter = ({ onChange, dataKey }: Props) => {
	const debounceSearch = useRef(
		debounce((value) => {
			onChange(value)
		}, DEBOUNCE_DELAY),
	).current
	const [value, setValue] = useState('')
	const filter = useSelector(datatableSelectors.getFilter(dataKey))

	useEffect(() => {
		setValue((filter?.value as string) || (filter?.placeholder ? filter.placeholder : ''))
	}, [filter.value])

	const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
		const { value } = e.target
		setValue(value)
		debounceSearch(value)
	}

	return <TextField fullWidth={true} onChange={handleChange} value={value} title={dataKey} />
}

export default React.memo(DatatableFulltextFilter)
